import React from 'react';
import Link from 'next/link';

const footerLinks = {
  Platform: [
    { label: 'Dividend Stocks', href: '/research' },
    { label: 'Forex Intelligence', href: '/work' },
    { label: 'Solutions', href: '/culture' },
    { label: 'Algorithmic Models', href: '/research' },
  ],
  Company: [
    { label: 'The Research Desk', href: '/research-desk' },
    { label: 'Methodology', href: '/methodology' },
    { label: 'Contact', href: '/contact' },
    { label: 'Member Dashboard', href: '/dashboard' },
  ],
  Legal: [
    { label: 'Privacy Policy', href: '/privacy-policy' },
    { label: 'Terms of Service', href: '/terms-of-service' },
    { label: 'Disclosure', href: '/disclosure' },
    { label: 'Risk Warning', href: '#' },
  ],
};

export default function Footer() {
  return (
    <footer
      style={{ background: '#0A2540', borderTop: '1px solid #0F4C81', fontFamily: 'var(--font-body)' }}
    >
      <div
        className="px-6 md:px-12 py-16"
        style={{ maxWidth: 'var(--container-max)', margin: '0 auto' }}
      >
        {/* Top row */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-12 mb-16">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link href="/homepage" className="flex items-center gap-3 mb-5">
              <div
                className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ background: 'linear-gradient(135deg, #4A90E2 0%, #A3D4FF 100%)' }}
              >
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M3 14L7 6L11 10L14 4" stroke="#0A2540" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="14" cy="4" r="1.5" fill="#0A2540"/>
                </svg>
              </div>
              <div>
                <span className="font-display text-lg font-bold text-white block leading-none" style={{ fontFamily: 'var(--font-display)' }}>
                  DividendChase
                </span>
                <span className="text-xs tracking-widest uppercase" style={{ color: '#A3D4FF', fontFamily: 'var(--font-mono)', fontSize: '9px' }}>
                  Institutional Research
                </span>
              </div>
            </Link>
            <p className="text-sm leading-relaxed mb-6" style={{ color: '#E3F2FD', opacity: 0.6, maxWidth: '280px' }}>
              Institutional-grade financial intelligence for dividend equities, global forex, and digital assets. Exclusively for qualified investors.
            </p>
            <div
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-mono"
              style={{ background: 'rgba(163,212,255,0.08)', border: '1px solid rgba(163,212,255,0.2)', color: '#A3D4FF', fontFamily: 'var(--font-mono)' }}
            >
              <span className="w-1.5 h-1.5 rounded-full bg-green-400 inline-block" />
              Markets Open · Live Data
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks)?.map(([category, links]) => (
            <div key={category}>
              <h4
                className="text-xs font-semibold uppercase tracking-widest mb-5"
                style={{ color: '#A3D4FF', fontFamily: 'var(--font-mono)', letterSpacing: '0.18em' }}
              >
                {category}
              </h4>
              <ul className="space-y-3">
                {links?.map((l) => (
                  <li key={l?.label}>
                    <Link
                      href={l?.href}
                      className="text-sm transition-colors duration-200 hover:text-white"
                      style={{ color: '#E3F2FD', opacity: 0.55 }}
                    >
                      {l?.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom row */}
        <div
          className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8"
          style={{ borderTop: '1px solid rgba(15,76,129,0.5)' }}
        >
          <p className="text-xs" style={{ color: '#E3F2FD', opacity: 0.4, fontFamily: 'var(--font-mono)' }}>
            © 2025 DividendChase LLC. All rights reserved. For qualified institutional investors only.
          </p>
          <div className="flex items-center gap-6">
            <Link href="/privacy-policy" className="text-xs transition-colors hover:text-white" style={{ color: '#E3F2FD', opacity: 0.4 }}>Privacy Policy</Link>
            <Link href="/terms-of-service" className="text-xs transition-colors hover:text-white" style={{ color: '#E3F2FD', opacity: 0.4 }}>Terms of Service</Link>
            <Link href="/contact" className="text-xs transition-colors hover:text-white" style={{ color: '#E3F2FD', opacity: 0.4 }}>Contact</Link>
          </div>
        </div>
        <p className="text-xs text-center mt-4" style={{ color: '#E3F2FD', opacity: 0.25 }}>
          Past performance is not indicative of future results. All research is for informational purposes only and does not constitute investment advice.
        </p>
      </div>
    </footer>
  );
}